import styled from "styled-components";

const StyledButtons = styled.button``;

export { StyledButtons };
